var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-box col-3 m-3 core-stat"},[_c('h3',{staticClass:"value",attrs:{"title":_vm.value}},[_vm._v(_vm._s(_vm.value || "-"))]),_c('span',{staticClass:"text-muted-light category"},[_vm._v(_vm._s(_vm.category))])])}
var staticRenderFns = []

export { render, staticRenderFns }